"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.deepReplaceContent = exports.replaceContent = void 0;
var replaceContent = function (inputString, replacements) {
    if (!inputString) {
        return '';
    }
    return inputString.replace(/{{([^{}]+)}}/g, function (_, key) {
        var replacement = replacements[key.trim()];
        return replacement !== undefined ? replacement : '';
    });
};
exports.replaceContent = replaceContent;
/** the types are hacked together but this will do a handlebars replacement on any string no matter how nested */
var deepReplaceContent = function (inputRecord, replacements) {
    if (typeof inputRecord === 'string') {
        return (0, exports.replaceContent)(inputRecord, replacements);
    }
    if (Array.isArray(inputRecord)) {
        return inputRecord.map(function (value) {
            return (0, exports.deepReplaceContent)(value, replacements);
        });
    }
    return Object.entries(inputRecord).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = (0, exports.deepReplaceContent)(value, replacements), _b)));
    }, {});
};
exports.deepReplaceContent = deepReplaceContent;
/** something I was cooking up on how to grab content and replacements all at the same time with type safety
 * this wont work unless we export screens as `ScreenContent` and define their replacement names
 */
// export interface ScreenContent<TContent extends RecursiveStringRecord, TReplacements extends readonly string[]> {
//   content: TContent
//   replacements: TReplacements
// }
// type RecordFromStringArray<TArray extends readonly string[]> = Record<TArray[number], string>
// import * as Screens from './screens'
// type ScreenKeys = keyof typeof Screens
// export const getScreenContent = <TScreen extends ScreenKeys>(screen: TScreen, replacements: RecordFromStringArray<typeof Screens[TScreen]['replacements']>) => {
//   return deepReplaceContent(Screens[screen].content, replacements)
// }
